__turbopack_context__.v({
  "likeCount": "styles-module__8jeyhq__likeCount",
  "linkContainer": "styles-module__8jeyhq__linkContainer",
});
